<template>
    <div>
        <router-link
            v-if="row.type === walletTransactionType.SETTLEMENT"
            :to="`/wallets/settlement-detail/${row.id}`"
        >
            <i class="fas fa-cog"></i>
        </router-link>
        <div
            @click="getData(row)"
            class="text-info" style="cursor: pointer"
            v-else-if="row.type == walletTransactionType.TRANSFER">
            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
            <i v-else class="fas fa-info"></i>
        </div>
        <div v-if="row.type === walletTransactionType.TRANSFER" class="modal fade" :id="`show_details_${row.id}`"
             tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
             aria-hidden="true">

            <div
                class="modal-dialog modal-lg modal-dialog-centered"
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="text-center">توضیحات</div>
                        <form class="mt-5 mx-5 mb-2">
                            <div class="row my-2 bg-white p-1">

                                <div class="col-12 col-md-4 my-2">
                                    <div class="text-left">{{ $t('label.total_amount') }}</div>
                                    <input class="form-control"
                                           :value="row.amount"
                                           disabled
                                    >
                                </div>
                                <div class="col-12 col-md-4 my-2">
                                    <div class="text-left">{{ $t('label.status') }}</div>
                                    <input
                                        :class="`form-control text-white bg-${walletTransactionStatusVariant(row.status)}`"
                                        :value="walletTransactionStatusStr.get(row.status) + (false ? ' (' + $t('label.reversal') + ')' : '')"
                                        disabled
                                    >
                                </div>

                                <div class="col-12 col-md-4 my-2">
                                    <div class="text-left">{{ $t('label.payment_date') }}</div>
                                    <input class="form-control"
                                           style="direction: ltr;"
                                           :value="row.created_at"
                                           disabled
                                    >
                                </div>

                                <div class="col-12 col-md-12 my-2">
                                    <div class="text-left">{{ $t('label.description') }}</div>

                                    <textarea class="form-control" :value="fetchTransfer.transfer_description" disabled
                                              rows="4"></textarea>
                                </div>

                            </div>

                            <table
                                class="table table-bordered bg-white"
                            >
                                <tr>
                                    <td
                                        v-text="
                                                    $t(
                                                        'wallets.receipt.user_to'
                                                    )
                                                "
                                    ></td>
                                    <td
                                        v-text="
                                                    $t(
                                                        'wallets.receipt.user_from'
                                                    )
                                                "
                                    ></td>

                                    <td
                                        v-text="
                                                    $t(
                                                        'wallets.receipt.wallet_id_from'
                                                    )
                                                "
                                    ></td>
                                    <td
                                        v-text="
                                                    $t(
                                                        'wallets.receipt.wallet_id_to'
                                                    )
                                                "
                                    ></td>

                                </tr>
                                <tr>
                                    <td v-if="fetchTransfer.from">{{ fetchTransfer.from.user }}</td>
                                    <td v-if="fetchTransfer.to">{{ fetchTransfer.to.user }}</td>
                                    <td v-if="fetchTransfer.from">{{ fetchTransfer.from.wallet_id }}</td>
                                    <td v-if="fetchTransfer.to">{{ fetchTransfer.to.wallet_id }}</td>
                                </tr>
                            </table>

                        </form>
                    </div>
                </div>
            </div>
        </div>


        <div v-if="[walletTransactionStatus.FAILED_NOT_SENT, walletTransactionStatus.FAILED].includes(row.status) && row.should_send_request" style="cursor: pointer;">
            <span @click="openModal(row)" class="fa fa-history"></span>

        </div>


        <div class="modal fade" data-backdrop="static" data-keyboard="false" :id="`approve_modal_${row.id}`"
             tabindex="-1" role="dialog">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <form @submit.prevent="sendRequest" class="row justify-content-end"
                              :id="`send_request_form_${row.id}`">
                            <div class="row px-4 justify-content-end">
                                <button type="button" @click="hideModal"
                                        class="btn btn-sm btn-circle btn-icon bg-white">
                                    <i class="fa fa-times "></i>
                                </button>
                            </div>
                            <div class="row pr-4 pb-4 w-100">
                                <label :for="`name_${row.id}`">کیف</label>
                                <input :name="`name_${row.id}`" :value="request_data.title" readonly type="text"
                                       class="form-control">
                            </div>
                            <div class="row pr-4 pb-4 w-100">
                                <label :for="`password_${row.id}`">رمز کیف</label>
                                <input name="password" v-model="request_data.password" :id="`password_${row.id}`"
                                       ref="password" type="password" class="form-control">
                            </div>
                            <div v-if="hasOtp && request_data.two_factor_type === TwoFactorType.GOOGLE_AUTHENTICATOR"
                                 class="row pr-4 pb-4 w-100">
                                <label
                                    for="google_authenticator_code">{{ $t('auth.login.google_authenticator_code') }}</label>
                                <kt-form-control
                                    v-bind:placeholder="$t('auth.login.google_authenticator_code')"
                                    name="google_authenticator_code"
                                    class="text-center"
                                    autocomplete="off"
                                    v-model="request_data.otp"
                                    type="text"
                                    id="google_authenticator_code"
                                    dir="ltr"
                                />
                                <a v-if="!loading" class="link mt-2 mr-1"
                                   @click="changeTwoFactorType(TwoFactorType.SMS)">{{ $t('label.send_request_with_sms') }}</a>
                                <button v-else :disabled="loading" class="btn btn-link mt-2 mr-1">
                                    {{ $t('label.send_request_with_sms') }}
                                </button>
                            </div>
                            <div v-else-if="hasOtp && request_data.two_factor_type === TwoFactorType.SMS"
                                 class="row pr-4 pb-4 w-100">
                                <label :for="`otp_${row.id}`">رمزیکبار مصرف</label>
                                <input name="otp" v-model="request_data.otp" :id="`otp_${row.id}`" ref="otp" type="text"
                                       class="form-control">
                                <a v-if="!loading_btn" class="link mt-2 mr-1"
                                   @click="changeTwoFactorType(TwoFactorType.GOOGLE_AUTHENTICATOR)">{{ $t('label.send_request_with_google') }}</a>
                                <button v-else :disabled="loading_btn" class="btn btn-link mt-2 mr-1">
                                    {{ $t('label.send_request_with_google') }}
                                </button>
                            </div>
                            <div class="d-flex px-1 justify-content-end mb-3">
                                <button @click="hideModal(row)"
                                        type="button"
                                        class="btn btn-danger btn-sm px-5 rounded-pill py-2 ml-2 font-weight-bold"
                                        style="font-size: 14px">انصراف
                                </button>
                                <button
                                    :disabled="loading_btn"
                                    class="btn btn-primary btn-sm rounded-pill px-5 py-2 mr-2  font-weight-bold"
                                    style="font-size: 14px">
                                    <span v-if="loading_btn" class="spinner-border"></span>
                                    <span v-else>ارسال</span>
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import {walletTransactionType} from "@/constants/walletTransactionType";
import $ from 'jquery';
import {withdrawTypeStr} from "@/constants/withdrawType";
import {
    walletTransactionStatus,
    walletTransactionStatusStr,
    walletTransactionStatusVariant
} from "@/constants/walletTransactionStatus";
import {bankIdStr} from "@/constants/bankId";
import {walletService} from "@/common/api.service";
import {TwoFactorType} from "@/constants/TwoFactorType";
import Inputmask from 'inputmask';
import Axios from "axios";

export default Vue.extend({
    data() {
        return {
            should_two_factor_settlement: false,
            walletTransactionStatusVariant,
            fetchTransfer: {},
            loading: false,
            request_data: {
                password: null,
                title: null,
                transaction_id: null,
                otp: null,
                wallet_id: null,
                two_factor_type: TwoFactorType.GOOGLE_AUTHENTICATOR
            }, hasOtp: false,
            loading_btn: false,
        }
    },
    computed: {
        TwoFactorType() {
            return TwoFactorType
        },
        walletTransactionStatus() {
            return walletTransactionStatus
        },
        bankIdStr() {
            return bankIdStr
        },
        walletTransactionStatusStr() {
            return walletTransactionStatusStr
        },
        destination_name() {
            return this.settlement_data.destination_firstname + ' ' + this.settlement_data.destination_lastname;
        },
        withdrawTypeStr() {
            return withdrawTypeStr
        },
        walletTransactionType() {
            return walletTransactionType
        }
    },
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        },
    },
    methods: {
        masked() {
            setTimeout(() => {
                document.getElementById("google_authenticator_code") &&
                Inputmask("9     9     9     9     9     9").mask(document.getElementById("google_authenticator_code"));
            }, 100);
        },
        changeTwoFactorType(type) {
            this.request_data.two_factor_type = type;
            this.request_data.otp = '';
            this.masked();
            if (type === TwoFactorType.SMS) {
                this.sendOtp($('#send_request_form'))
            }
        },
        sendOtp(form) {
            form.validate({
                ignore: ":hidden",
                rules: {
                    password: {
                        required: true
                    }
                }
            });

            if (!form.valid()) return false;

            let params = {
                wallet_id: this.request_data.wallet_id,
                two_factor_type: this.request_data.two_factor_type,
                password: this.request_data.password,
            }

            this.loading_btn = true;

            walletService.sendVerificationCode(params).then(response => {
                this.hasOtp = true;
                this.request_data.two_factor_type = response.data.data.two_factor_type;
                this.masked();
                this.$forceUpdate();
                this.toastr.success(response.data.message);

            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message);

                if (response.data && response.data.data) {
                    form.validate().showErrors(response.data.data);
                }
            }).finally(() => {
                this.loading_btn = false;
            });
        },
        openModal(tr) {
            this.request_data.title = tr.wallet.title;
            this.request_data.wallet_id = tr.wallet_hashid;
            this.request_data.transaction_id = tr.id;
            $(`#approve_modal_${tr.id}`).modal('show');
        },
        sendRequest(event) {
            if (this.should_two_factor_settlement && !this.hasOtp) {
                this.sendOtp($(event.target))
            } else {

                let form = $(event.target);

                let params = {
                    wallet_id: this.request_data.wallet_id,
                    password: this.request_data.password,
                    should_two_factor_settlement: this.request_data.should_two_factor_settlement,
                    otp: !this.request_data.otp ? '' : this.request_data.otp.replace(/\s+/g, ''),
                    two_factor_type: !this.request_data.two_factor_type ? "" : this.request_data.two_factor_type ,
                    transaction_id: this.request_data.transaction_id,
                }

                this.loading_btn = true;

                walletService.resendSettlement(params).then(response => {
                    this.hasOtp = false;
                    this.hideModal(params.transaction_id)

                    this.toastr.success(response.data.message);

                    window.location.reload();
                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message);

                    if (response.data && response.data.data) {
                        form.validate().showErrors(response.data.data);
                    }
                }).finally(() => {
                    this.loading_btn = false;
                });

            }

        },
        hideModal(tr) {
            this.request_data.otp = null;
            this.hasOtp = false;
            this.request_data.two_factor_type = TwoFactorType.GOOGLE_AUTHENTICATOR;
            this.masked();
            $(`#approve_modal_${tr.id}`).modal('hide');

        },
        getData(row) {
            this.fetchTransfer = {};
            this.loading = true;
            walletService.getSettlementDetailAyande(row.id).then(res => {
                this.fetchTransfer = res.data.data;
                $(`#show_details_${row.id}`).modal("show")
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message);
            }).finally(() => {
                this.loading = false;
            });

        }
    },
    mounted() {
        Axios.get('wallet/common?wallet_prefix=A').then(response => {
            response.data.data.forEach(wallet => {
                if (wallet.id === this.$route.params.hashid) {
                    this.should_two_factor_settlement = wallet.should_two_factor_settlement;
                    this.form_data.should_two_factor_settlement = wallet.should_two_factor_settlement;
                }
            })
        });
    }

})
</script>

<style scoped>
.link {
    color: #0f9af0 !important;
    cursor: pointer;
}

.link:hover {
    border-bottom: 1px solid #0f9af0;
}
</style>